import React from 'react';
import { useParams } from 'react-router-dom';
import PlayerIntelligence from '../components/intel/PlayerIntelligence';

export default function PlayerDetails() {
  const { id } = useParams();
  return <PlayerIntelligence playerId={id} />;
}
